import { render, staticRenderFns } from "./ListaAtividadeDisciplinaHabilidade.vue?vue&type=template&id=782535e0"
import script from "./ListaAtividadeDisciplinaHabilidade.vue?vue&type=script&lang=js"
export * from "./ListaAtividadeDisciplinaHabilidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports